import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../../components/AuthProvider';

const ProtectedRoute = ({ children }) => {
	const { isAuthenticated, isLoading } = useAuthContext();

	if (isLoading) {
		return (
			<div className="flex items-center justify-center min-h-screen">
				<div className="text-center">
					<div className="animate-spin rounded-full h-32 w-32 border-b-2 border-dark-blue mx-auto"></div>
					<p className="mt-4 text-dark-blue">Loading...</p>
				</div>
			</div>
		);
	}

	if (!isAuthenticated) {
		return <Navigate to="/login" replace />;
	}

	return children;
};

export default ProtectedRoute;
